const state = {
    // 云台
    mountGB: {},
    // 喊话器
    mountSPK: {},
    // 网关
    mountGW: {},
    // TC
    mountTC: {},
    // 生命探测雷达
    mountLDR: undefined,
    // 飞控
    mountFC: {},
    // 十字架样式
    crossStyle: sessionStorage.getItem("crossStyle") * 1 || undefined,
    // 目标锁定
    targetLock: false,
    // 目标锁定解算
    targetSolutionVisible: false,
    // 目标识别统计表格
    targetRecognitionTableVisible: false,
    // 云台通用状态
    generalStateGB: '[]',
    audioPlaylist: '[]',
    // 云台录像状态
    recordingStatus: undefined,
    // 避障开关
    obstacleAvoidanceSwitch: 0,
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
